<template>
  <div class="fu-step">
    <div class="fu-step-header">
      <button type="button" class="fu-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotUsernameMobile">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fu-back-icon"
        />
      </button>
      <h1 class="fu-step-title">{{ $t('lbl_emp2_RetrieveUsername') }}</h1>
    </div>

    <div class="fu-form-group">
      <div class="fu-info-text" v-html="$t('lbl_emp2_EnterAdminMobileForUsername')">
      </div>
    </div>

    <div class="fu-form-group">
      <div class="fu-input-wrapper">
        <selection
          style="margin-bottom: 0px;"
          :title="$t('lbl_emp2_CountryRegion')"
          label="Name"
          class="mobile-country-select"
          :value="countryCode"
          :options="selectionCountryOptions"
          :ControlId="'fu-mobile-country-select'"
          :multiple="false"
          @input="handleCountryCodeInput"
          @fromChird_TreeSelected="handleCountrySelected($event)"
        >
        </selection>
      </div>

      <div class="fu-input-wrapper">
        <div class="fu-input-container">
          <label
            v-if="shouldShowLabel(mobileNumber, mobileError)"
            class="input-label"
            :class="{ 'label-error': mobileError }"
          >
            {{ $t('lbl_emp2_MobileNumber') }} <span class="required">*</span>
          </label>
          <span
            v-if="shouldShowPlaceholder(mobileNumber, mobileError)"
            class="input-placeholder"
          >
            {{ $t('lbl_emp2_MobileNumber') }} <span class="required">*</span>
          </span>
          <input
            :value="mobileNumber"
            type="tel"
            name="tel"
            id="forgot-username-tel-field"
            autocomplete="tel"
            class="form-input-placeholder"
            :class="{ 'input-error': mobileError }"
            placeholder=""
            @focus="() => onFocus('clear-error')"
            @blur="onBlur"
            @input="handleInput"
          />
        </div>
        <div v-if="mobileError" class="fu-error-message">
          {{ $t('lbl_emp2_InvalidMobileNumber') }}
        </div>
      </div>
    </div>

    <button
      class="fu-btn-primary"
      @click="$emit('continue')"
      :disabled="!isValidMobile || loading"
      t_label="btn_emp2_Continue_ForgotUsernameMobile"
    >
      {{ $t('lbl_emp2_Continue') }}
    </button>
  </div>
</template>

<script>
import inputMixin from '../Common/input-mixin.js';
import { validateMobileWithCountry } from '../Common/utils.js';

export default {
  name: 'ForgotUsernameMobile',
  mixins: [inputMixin],
  props: {
    countryCode: {
      type: String,
      default: '+86'
    },
    countryOptions: {
      type: Array,
      default: () => []
    },
    mobileNumber: {
      type: String,
      default: ''
    },
    mobileError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    normalizedCountryOptions() {
      if (this.countryOptions && this.countryOptions.length > 0) {
        return this.countryOptions;
      }
      return [];
    },
    // 供 selection 组件使用的国家选项（id/label 结构），与登录页 MobileStep 保持一致
    selectionCountryOptions() {
      if (this.countryOptions && this.countryOptions.length > 0) {
        return this.countryOptions.map(option => ({
          id: option.value,
          label: option.text
        }));
      }
      return [];
    },
    // 统一的手机号基础格式校验：必须选择国家码 + 合法手机号
    isValidMobile() {
      return validateMobileWithCountry(this.countryCode, this.mobileNumber);
    }
  },
  methods: {
    handleInput(event) {
      this.handleInputGeneric(event, 'update:mobileNumber', 'clear-error');
    },
    handleCountryChange(event) {
      this.$emit('update:countryCode', event.target.value);
    },
    // 与登录页 MobileStep 保持一致的国家选择事件处理
    handleCountryCodeInput(value) {
      // selection 组件的 @input 事件直接传递选中的值（id）
      this.$emit('update:countryCode', value);
    },
    handleCountrySelected(obj) {
      // selection 组件通过 fromChird_TreeSelected 事件传递 { id, label } 对象
      this.$emit('update:countryCode', obj.id);
    }
  }
};
</script>

<style>
@import '../Common/new-login-shared.css';
</style>

<style scoped>
.fu-input-container {
  width: 100%;
  position: relative;
  overflow: visible;
  background: transparent;
}

.fu-input-container.fu-input-error {
  outline-color: #CD1515 !important;
}

.fu-input-container-select {
  position: relative;
  margin-bottom: 0;
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  background: transparent !important;
  display: block !important;
  width: 100%;
}

.cu-form-label {
  position: absolute;
  left: 15px;
  top: -8px;
  padding: 0 5px;
  background-color: #F8F8F8;
  margin-bottom: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  z-index: 10;
  pointer-events: none;
}

.cu-required {
  color: #CD1515;
  margin-left: 2px;
}

.fu-input-container-select .cu-form-select {
  width: 100%;
  padding: 12px 40px 12px 15px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  background: white;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.fu-input-container-select .cu-form-select:focus {
  outline: none;
  border-color: #7366FF;
}

.fu-input-container-select::after {
  content: '';
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid rgba(0, 0, 0, 0.54);
  pointer-events: none;
  z-index: 1;
}
</style>

